import React from 'react';

import Cookies from 'universal-cookie';
import { joinNames } from '../../utils/common';
import { useAppStore, useAuthStore } from '../../stores';

const cookies = new Cookies();

const TimeoutMessage = () => {
  const personalizationActive = useAppStore((state) => state.personalizationActive);
  const salespersonName = useAuthStore((state) => state.salespersonName);

  const resident = cookies.get( 'resident' );

  let residentNames = '';
  if ( personalizationActive ) {
    residentNames = joinNames( resident.first_name, resident.last_name, resident.person2_first_name, resident.person2_last_name, null, ' and ' );
  }

  return (
    <div className="modal__subsection modal__description">
      You've been idle for a while. To prevent problems,

      { personalizationActive
        && (
        <>
          &nbsp;personalization for
          {' '}
          <span>{residentNames}</span>
          {' '}
          will be saved and
        </>
        )}
      {' '}
      {salespersonName}
      {' '}
      will be logged out in:
    </div>
  );
};

export default TimeoutMessage;
